import {disablePageScroll, enablePageScroll} from 'scroll-lock';
import UiElement from '../../../shared/ui-element/ui-element';

import './global-search.scss';

class GlobalSearch extends UiElement {
  ui = {
    searchButton: '.site-navigation__link-search',
    searchArea: '.js-global-search-area',
    searchAreaOverlay: '.search-area__overlay',
    searchInput: '.search-area__input',
    navigationSearchInput: '.site-navigation-search__input',
    headerSearchInput: '.js-apps-search-input',
    closeSearchAreaBtn: '.js-close-search-btn',
  };

  uiCollections = {
    clearNavigationSearchBtn: '.js-clear-search-btn',
  };

  events = {
    'click @ui.searchButton': 'handleSearchButtonClick',
    'click @ui.searchArea': 'handleSearchAreaClick',
    'click @ui.closeSearchAreaBtn': 'handleSearchAreaClick',
    'click @uiCollections.clearNavigationSearchBtn': 'handleClearSearchBtn',
    'input @ui.navigationSearchInput': 'handleSearchInput',
  };

  onInit() {
    if (this.ui.headerSearchInput) {
      const queryString = this.ui.headerSearchInput.dataset.query;
      if (queryString) {
        this.ui.headerSearchInput.value = queryString;
        this.handleSearchInput({target: this.ui.headerSearchInput});
      }

      this.ui.headerSearchInput.addEventListener('input', this.handleSearchInput);
    }
  }

  handleSearchButtonClick() {
    this.ui.searchAreaOverlay.classList.add('search-area__overlay-visible');
    this.ui.searchAreaOverlay.classList.remove('search-area__overlay-hidden');
    disablePageScroll(this.ui.searchAreaOverlay);
    setTimeout(() => {
      this.ui.closeSearchAreaBtn.classList.add('search-area__input-close-visible');
      this.ui.searchInput.classList.add('search-area__input-visible');
      this.ui.searchInput.focus();
    }, 300);
  }

  handleSearchAreaClick(e) {
    const isInput = e.target === this.ui.searchInput;
    if (!isInput) {
      this.ui.searchInput.value = '';
      this.ui.closeSearchAreaBtn.classList.remove('search-area__input-close-visible');
      this.ui.searchInput.classList.remove('search-area__input-visible');
      setTimeout(() => {
        this.ui.searchAreaOverlay.classList.remove('search-area__overlay-visible');
        this.ui.searchAreaOverlay.classList.add('search-area__overlay-hidden');
      }, 300);
      enablePageScroll(this.ui.searchAreaOverlay);
    }
  }

  handleSearchInput({target}) {
    const closeBtn = target.nextElementSibling.closest('.js-clear-search-btn');
    closeBtn.classList.remove('btn__input-close_hidden');
    if (target.value.length === 0) {
      closeBtn.classList.add('btn__input-close_hidden');
    }
  }

  handleClearSearchBtn({target}) {
    const input = target.previousElementSibling.closest('input');
    input.value = '';
    target.classList.add('btn__input-close_hidden');
  }
}

export default GlobalSearch;
